export const da = {
  myPackHomeTitle: "Levering til hjemmeadresse med PostNord MyPack Home",
  myPackHomeDesc: "Pakken leveres til din adresse",
  myPackCollectTitle: "Levering til udleveringssted i nærheden med PostNord MyPack Collect",
  myPackCollectDesc: "Hent pakken på udleveringssted nær din adresse"
};

export const en = {
  myPackHomeTitle: "Shipping to home address with PostNord MyPack Home",
  myPackHomeDesc: "Package is delivered to your home address",
  myPackCollectTitle: "Shipping to nearby collection point with PostNord MyPack Collect",
  myPackCollectDesc: "Pick up package at a selected pickup address"
};
